import { createContext, useMemo, useState } from "react";

export const UserContext = createContext({
    user: {},
    setUser: () => { }
});

//provide user for multiple components
export default function UserProvider({ children }) {

    const [user, setUser] = useState({
        "calendarEntries": [],
        "vpnNumber": "",
        "email": ""
    });
    
    const value = useMemo(
        () => ({ user, setUser }),
        [user]
    );
    
    return <UserContext.Provider value={value}>{children}</UserContext.Provider>
};